import { Order } from "../Types/ResponseTypes/Order";

export const mockOrder: Order = {
    "orderId": "005-8653900",
    "created": "",
    "lastSynced": "",
    "deliveries": [],
};